<template>
  <div class="history-page page-with-tabbar">
    <van-nav-bar title="竞价记录" fixed :placeholder="true" />
    <div class="content">
      <van-pull-refresh v-model="refresh" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, index) in tableData" :key="item.order_id || index" class="order-card-outer">
            <div class="order-card-strict">
              <!-- 上部分 -->
              <div class="order-card-top">
                <div class="top-left">
                  <div class="cinema-name">{{ item.cinema_name }}</div>
                  <div class="order-row">
                    <span class="order-id">{{ item.order_id }}</span>
                    <span class="copy-btn" @click="copyOrderNo(item.order_id)">复制</span>
                  </div>
                </div>
                <div class="top-right">
                  <div class="market-price">
                    <span>市场价:</span><span class="market-price-num">￥{{ item.channel_price }}</span>
                  </div>
                  <div class="status-info">
                    <span class="status-text" :class="getStatusClass(item.status_text)">{{ item.status_text }}</span>
                  </div>
                </div>
              </div>
              <!-- 分割线 -->
              <div class="order-card-divider"></div>
              <!-- 下部分 -->
              <div class="order-card-bottom">
                <div class="bottom-left">
                  <div class="movie-img-box">
                    <van-image width="80px" height="100%" fit="cover" :src="item.logo+'_200x200'" />
                  </div>
                  <div class="movie-info-box">
                    <div class="movie-title">{{ item.movie_name }}</div>
                    <div class="movie-tags">
                      <span class="ticket-count">{{ item.quantity }}张</span>
                      <span v-if="item.support_exchange_seat == 'Y'" class="seat-type-tag">九宫格换座</span>
                      <span v-if="item.seat_tag" class="seat-type-tag">{{ item.seat_tag }}</span>
                    </div>
                    <div class="showtime-row">
                      <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                      <span class="showtime">{{ item.play_time_text }}</span>
                    </div>
                    <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                  </div>
                </div>
                <div class="bottom-right">
                  <div class="city-name">{{ item.city_name }}</div>
                  <div class="price-info">
                    <div class="my-bid-price">
                      <span>我的报价:</span>
                      <span class="price-num">￥{{ item.my_bid_price }}</span>
                    </div>
                    <!-- <div v-if="item.bid_price > 0" class="win-price">
                      <span>中标价:</span>
                      <span class="price-num win">￥{{ item.bid_price }}</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <van-empty v-if="finished && !loading && tableData.length === 0" class="product-empty" image="search" description="暂无竞价记录" />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'
export default {
  name: "History",
  data(){
    return {
      tableData:[],
      queryData:{
        page:1,
        pageSize:10
      },
      loading:false,
      finished:false,
      refresh:false,
    }
  },
  created() {
    // 1. 页面首次打开，请求一次
    this.fetchData();
  },
  methods:{
    // 2. 下拉刷新请求
    onRefresh(){
      this.queryData.page = 1;
      this.tableData = [];
      this.finished = false;
      this.loading = false;
      this.fetchData();
    },
    fetchData(){
      this.loading = true;
      Api.bidRecord(this.queryData).then(res=>{
        this.loading = false;
        this.refresh = false;
        
        if (res.list && res.list.length > 0) {
          res.list.forEach(item=>{
            this.tableData.push(item);
          });
          
          // 判断是否还有更多数据
          if(res.list.length < this.queryData.pageSize){
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          // 没有数据时，标记为已完成
          this.finished = true;
        }
      }).catch(err=>{
        this.loading = false;
        this.refresh = false;
        console.error('获取竞价记录失败:', err);
      });
    },
    // 3. 向下滚动，翻页请求
    onLoad(){
      if (this.finished) {
        return;
      }
      this.queryData.page++;
      this.fetchData();
    },
    getStatusClass(statusText) {
      if (statusText.includes('中标')) {
        return 'status-success';
      } else if (statusText.includes('未中标')) {
        return 'status-fail';
      } else if (statusText.includes('已取消')) {
        return 'status-cancel';
      }
      return 'status-default';
    },
    copyOrderNo(orderId) {
      if (!orderId) return;
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(orderId).then(() => {
          this.$toast.success('复制成功');
        }).catch(() => {
          this.$toast.fail('复制失败');
        });
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement('textarea');
        textArea.value = orderId;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$toast.success('复制成功');
        } catch (err) {
          this.$toast.fail('复制失败');
        }
        document.body.removeChild(textArea);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.history-page {
  background: #f7f7fa;
  min-height: 100vh;

  .content {
    padding-top: 10px;
  }
}

.order-card-outer {
  margin: 20px 12px;
}

.order-card-strict {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 14px 0 14px 10px; // 右边为0
  display: flex;
  flex-direction: column;
  font-family: inherit;
  min-height: 200px;
}

.order-card-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2px;
  flex-shrink: 0;
}

.top-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.cinema-name {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  line-height: 1.2;
  margin-bottom: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.order-id {
  font-size: 12px;
  color: #888;
  font-family: monospace;
}

.copy-btn {
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: rgba(24, 144, 255, 0.1);
  transition: background-color 0.2s;

  &:active {
    background-color: rgba(24, 144, 255, 0.2);
  }
}

.top-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  min-width: 70px;
  margin-left: 8px;
}

.market-price {
  font-size: 13px;
  margin-bottom: 2px;
  color: #888;
}

.market-price-num {
  color: #ff2c54;
  font-weight: bold;
  margin-left: 2px;
}

.status-info {
  margin-top: 4px;
}

.status-text {
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  
  &.status-success {
    background-color: #e8f5e8;
    color: #52c41a;
  }
  
  &.status-fail {
    background-color: #fff2f0;
    color: #ff4d4f;
  }
  
  &.status-cancel {
    background-color: #f5f5f5;
    color: #999;
  }
  
  &.status-default {
    background-color: #e6f7ff;
    color: #1890ff;
  }
}

.order-card-bottom {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(90px, auto);
  min-height: 120px;
  margin-top: 4px;
  gap: 0;
  justify-content: space-between;
}

.bottom-left {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
}

.movie-img-box {
  flex-shrink: 0;
  margin-right: 12px;
  height: 100%;
  display: flex;
  align-items: stretch;
}

.movie-img-box .van-image {
  width: 80px !important;
  height: 100% !important;
}

.movie-info-box {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.movie-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.movie-tags {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  gap: 6px;
}

.ticket-count {
  background: #f7f8fa;
  border-radius: 8px;
  font-size: 10px;
  padding: 1px 1px;
}

.seat-type-tag {
  border: 2px solid rgb(0, 140, 255);
  color: rgb(0, 140, 255);
  border-radius: 2px;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 2px;
}

.showtime-row {
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.hall-name {
  font-size: 13px;
  color: #888;
  margin-bottom: 2px;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.today-tag {
  display: inline-block;
  color: white;
  background-color: #ff2c53da;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px 2px 4px;
  margin-right: 2px;
  line-height: 1.2;
  vertical-align: middle;
  border-radius: 2px;
  clip-path: polygon(
    0 0,
    calc(100% - 8px) 0,
    100% 50%,
    calc(100% - 8px) 100%,
    0 100%
  );
}

.showtime {
  color: #333;
}

.seats-info {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.bottom-right {
  min-width: 90px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding-right: 10px;
}

.city-name {
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
  text-align: center;
}

.price-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
}

.my-bid-price, .win-price {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.price-num {
  font-weight: bold;
  color: #ff2c54;
  
  &.win {
    color: #52c41a;
  }
}

.order-card-divider {
  height: 1px;
  background: #eee;
  margin: 2px 0 8px 0;
  width: 100%;
}
</style>
